export default "__VITE_ASSET__BuX0fPS8__"